"use client"

import { useRef, useState } from "react"
import { addImageByPlan, addImageByBanner } from "../../../../lib/api.js"
import "../../../../theme/tailwind/custom-file-input.css"
import { Upload } from "lucide-react"

export function CustomFileInput({ numP, onImageAdded, entityType }) {
  const [imageFile, setImageFile] = useState(null)
  const [error, setError] = useState(null)
  const [showForm, setShowForm] = useState(false)
  const fileInputRef = useRef(null)

  const handleFileSelect = (e) => {
    if (e.target.files?.[0]) {
      setImageFile(e.target.files[0])
      setError(null)
    }
  }

  const handleDragOver = (e) => e.preventDefault()

  const handleDrop = (e) => {
    e.preventDefault()
    const file = e.dataTransfer.files?.[0]
    if (file) setImageFile(file)
  }

  const handleUploadClick = () => fileInputRef.current?.click()

  const handleSubmit = async () => {
    if (!imageFile) {
      return setError("Si prega di selezionare un'immagine.")
    }

    const formData = new FormData()
    formData.append("file", imageFile)

    if (entityType === "banner") {
      formData.append("IdBanner", numP.toString())
    } else {
      formData.append("IdPianificazione", numP.toString())
    }

    formData.append("Link", "")
    formData.append("NuovoTab", "0")
    formData.append("Nome", imageFile.name)

    try {
      if (entityType === "banner") {
        await addImageByBanner(formData)
      } else {
        await addImageByPlan(formData)
      }
      onImageAdded()
      setImageFile(null)
      setShowForm(false)
    } catch (err) {
      setError(err instanceof Error ? err.message : "Errore sconosciuto")
    }
  }

  const handleCancel = () => {
    setImageFile(null)
    setError(null)
    setShowForm(false)
  }

  return (
    <div id={`FileInput${numP}`} className="file-input-container">
      {!showForm ? (
        <button className="btn-add" onClick={() => setShowForm(true)}>
          Aggiungi immagine
        </button>
      ) : (
        <>
          <h3 className="text-lg font-semibold text-center">Aggiungi immagine</h3>
          <div className="drop-zone" onDragOver={handleDragOver} onDrop={handleDrop} onClick={handleUploadClick}>
            {!imageFile ? (
              <div className="flex flex-col items-center gap-2">
                <Upload className="w-8 h-8 text-gray-400" />
                <p className="drop-text">Scegli il file o trascinalo qui</p>
              </div>
            ) : (
              <img
                src={URL.createObjectURL(imageFile) || "/placeholder.svg"}
                alt="Anteprima"
                className="uploaded-image"
              />
            )}
          </div>
          <input type="file" accept="image/*" ref={fileInputRef} onChange={handleFileSelect} className="hidden-input" />

          <div className="btn-container">
            <button className="btn-original" onClick={handleCancel}>
              Annulla
            </button>
            <button className="btn-original" onClick={handleSubmit}>
              Carica
            </button>
          </div>
        </>
      )}

      {error && <p className="error-message">{error}</p>}
    </div>
  )
}
